import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const HomePage = () => {
  const webUrl = process.env.REACT_APP_WEB_URL;
  const [email, setEmail] = useState('');
  const [errors] = useState({});

  return (
    <div>
      {/* Navigation */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
        <div className="container">
          <a className="navbar-brand pb-12" href={webUrl}>
            <img
              src={webUrl + "/assets/images/logo.png"}
              style={{ maxHeight: "40px" }}
              alt='logo'
            />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="#portfolio">About Us</a></li>
              <li className="nav-item"><a className="nav-link" href="#newsroom">Industries</a></li>
              <li className="nav-item"><a className="nav-link" href="#newsroom">Blog</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        className="py-1 text-left text-white"
        style={{
          backgroundImage: `url("${process.env.REACT_APP_WEB_URL}/assets/images/auth/site_wide_shot-2.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          lineHeight: '1',
        }}
      >
        <div className="container p-64">
          <div
            className="fw-bold text-left py-16 mb-16"
            style={{ fontSize: '5rem', width: '60%' }}
          >Take control of your maintenance.</div>
          <div
            className="mb-32"
            style={{ fontSize: '32px' }}
          >Let's Get to Work.</div>
          <div className="d-flex align-items-center gap-2 w-50">
            <InputGroup>
              <InputGroup.Text>
                <Icon icon="mage:email" style={{ fontSize: '1.25rem' }} />
              </InputGroup.Text>
              <Form.Control
                type="email"
                placeholder="Enter your work email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={errors.email ? 'is-invalid' : ''}
                required />
            </InputGroup>
            <button className="btn btn-primary btn-sm" style={{ width: '150px' }}>
              Try for Free
              <Icon
                icon="mage:arrow-right-circle-fill"
                className="ms-8"
                style={{
                  fontSize: '.85rem',
                  position: 'relative',
                  top: '-2px'
                }} />
            </button>
          </div>
        </div>
      </section>
      {/* Functionaility Section */}
      <seciton id="functionaility" >
        <div className="container py-5">
          <ul
            className="nav button-tab nav-pills mb-16"
            id="pills-tab-four"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10 active"
                id="pills-button-icon-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-button-icon-home"
                type="button"
                role="tab"
                aria-controls="pills-button-icon-home"
                aria-selected="true"
              >
                <Icon
                  icon="solar:home-smile-angle-outline"
                  className="text-xl"
                />
                <span className="line-height-1">Asset Management</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                id="pills-button-icon-details-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-button-icon-details"
                type="button"
                role="tab"
                aria-controls="pills-button-icon-details"
                aria-selected="false"
              >
                <Icon
                  icon="hugeicons:folder-details"
                  className="text-xl"
                />
                <span className="line-height-1">Work Management</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                id="pills-button-icon-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-button-icon-profile"
                type="button"
                role="tab"
                aria-controls="pills-button-icon-profile"
                aria-selected="false"
              >
                <Icon icon="iconamoon:profile" className="text-xl" />
                <span className="line-height-1">Forms &amp; Procedures</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                id="pills-button-icon-settings-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-button-icon-settings"
                type="button"
                role="tab"
                aria-controls="pills-button-icon-settings"
                aria-selected="false"
              >
                <Icon icon="uil:setting" className="text-xl" />
                <span className="line-height-1">Inventory Management</span>
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tab-fourContent">
            <div
              className="tab-pane fade show active"
              id="pills-button-icon-home"
              role="tabpanel"
              aria-labelledby="pills-button-icon-home-tab"
              tabIndex={0}
            >
              <div className="d-flex align-items-center gap-3">
                <div className="flex-shrink-0">
                  <img
                    src="assets/images/tabs/tabs-image2.png"
                    className="radius-8"
                    alt=""
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="text-lg mb-8">Title</h6>
                  <p className="text-secondary-light mb-16">
                    Lorem Ipsum&nbsp;is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to{" "}
                  </p>
                  <p className="text-secondary-light mb-0">
                    {" "}
                    make a type specimen book. It has survived not industry's
                    standard dummy
                  </p>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-button-icon-details"
              role="tabpanel"
              aria-labelledby="pills-button-icon-details-tab"
              tabIndex={0}
            >
              <div className="d-flex align-items-center gap-3">
                <div className="flex-shrink-0">
                  <img
                    src="assets/images/tabs/tabs-image1.png"
                    className="radius-8"
                    alt=""
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="text-lg mb-8">Title</h6>
                  <p className="text-secondary-light mb-16">
                    Lorem Ipsum&nbsp;is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to{" "}
                  </p>
                  <p className="text-secondary-light mb-0">
                    {" "}
                    make a type specimen book. It has survived not industry's
                    standard dummy
                  </p>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-button-icon-profile"
              role="tabpanel"
              aria-labelledby="pills-button-icon-profile-tab"
              tabIndex={0}
            >
              <div className="d-flex align-items-center gap-3">
                <div className="flex-shrink-0">
                  <img
                    src="assets/images/tabs/tabs-image2.png"
                    className="radius-8"
                    alt=""
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="text-lg mb-8">Title</h6>
                  <p className="text-secondary-light mb-16">
                    Lorem Ipsum&nbsp;is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to{" "}
                  </p>
                  <p className="text-secondary-light mb-0">
                    {" "}
                    make a type specimen book. It has survived not industry's
                    standard dummy
                  </p>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-button-icon-settings"
              role="tabpanel"
              aria-labelledby="pills-button-icon-settings-tab"
              tabIndex={0}
            >
              <div className="d-flex align-items-center gap-3">
                <div className="flex-shrink-0">
                  <img
                    src="assets/images/tabs/tabs-image1.png"
                    className="radius-8"
                    alt=""
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="text-lg mb-8">Title</h6>
                  <p className="text-secondary-light mb-16">
                    Lorem Ipsum&nbsp;is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to{" "}
                  </p>
                  <p className="text-secondary-light mb-0">
                    {" "}
                    make a type specimen book. It has survived not industry's
                    standard dummy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </seciton>
      {/* Portfolio Section */}
      <section id="portfolio" className="py-5">
        <div className="container">
          <h2 className="mb-4 text-center">Our Work</h2>
          <div className="row g-4">
            {['Hemisferio', 'Atlanta Construction', 'Ethereum', 'Savvy & Co'].map((title, index) => (
              <div className="col-md-6 col-lg-3" key={index}>
                <div className="card h-100">
                  <img
                    src={process.env.REACT_APP_WEB_URL + "/assets/images/website/excavator-truck.png"}
                    style={{ maxHeight: "200px" }}
                    className="card-img-top"
                    alt={title}
                  />
                  <div className="card-body">
                    <h5 className="card-title">
                      {title}
                      <small className="d-block text-muted">Project · 2024</small>
                    </h5>
                    <a href={webUrl} className="stretched-link">Show more</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsroom Section */}
      <section id="newsroom" className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-4">Newsroom</h2>
          <div className="list-group">
            <a href={webUrl} className="list-group-item list-group-item-action">
              <h5 className="mb-1">Maximising ROI with Data-Driven Marketing Campaigns</h5>
              <small>22 April 2024 · Insights, Technology</small>
            </a>
            <a href={webUrl} className="list-group-item list-group-item-action">
              <h5 className="mb-1">Navigating the Challenges of Digital Transformation</h5>
              <small>27 March 2024 · Strategy, Business</small>
            </a>
            <a href={webUrl} className="list-group-item list-group-item-action">
              <h5 className="mb-1">How Design Thinking Fuels Innovation</h5>
              <small>15 February 2024 · UX, Creativity</small>
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5 text-center">
        <div className="container">
          <h2 className="mb-3">Get in Touch</h2>
          <p className="mb-1">info@avadacompany.com</p>
          <p>(555) 802‑1234</p>
          <a href="mailto:info@avadacompany.com" className="btn btn-outline-primary mt-3">Send Message</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-center py-3 bg-white border-top">
        <small>&copy; 2025 AvadaPortfolio. All rights reserved.</small>
      </footer>
    </div>
  );
};

export default HomePage;
